<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Diary of a Manwhore</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#prelude">Prelude</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-1-starting-out">Chapter 1 Starting Out</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-2-the-market-had-changed">Chapter 2 The Market Had Changed</a></li>
<li id="toc-li-6"><span href="#/text/ch006#chapter-3-my-funnel" title="Link target outside of Sample">Chapter 3 My Funnel</span><ol class="toc"><li id="toc-li-7"><span href="#/text/ch006#the-challenge" style="font-weight:normal;font-style:italic" title="Link target outside of Sample">3.1. The Challenge</span></li>
<li id="toc-li-8"><span href="#/text/ch006#the-fantasy" style="font-weight:normal;font-style:italic" title="Link target outside of Sample">3.2. The Fantasy</span></li>
<li id="toc-li-9"><span href="#/text/ch006#the-future" style="font-weight:normal;font-style:italic" title="Link target outside of Sample">3.3. The Future</span></li>
</ol></li>
<li id="toc-li-10"><span href="#/text/ch007#chapter-4-date-12-the-architect" title="Link target outside of Sample">Chapter 4 Date 12 – The Architect</span></li>
<li id="toc-li-11"><span href="#/text/ch008#chapter-5-date-23-the-cop" title="Link target outside of Sample">Chapter 5 Date 23 – The Cop</span></li>
<li id="toc-li-12"><span href="#/text/ch009#chapter-6-date-33-the-travel-agent" title="Link target outside of Sample">Chapter 6 Date 33 – The Travel agent</span></li>
<li id="toc-li-13"><span href="#/text/ch010#chapter-7-date-51-the-psychologist" title="Link target outside of Sample">Chapter 7 Date 51 – The Psychologist</span></li>
<li id="toc-li-14"><span href="#/text/ch011#chapter-8-date-59-the-food-writer" title="Link target outside of Sample">Chapter 8 Date 59 – The Food Writer</span></li>
<li id="toc-li-15"><span href="#/text/ch012#chapter-9-date-63-the-widow" title="Link target outside of Sample">Chapter 9 Date 63 – The Widow</span></li>
<li id="toc-li-16"><span href="#/text/ch013#chapter-10-date-79-the-university-lecturer" title="Link target outside of Sample">Chapter 10 Date 79 – The University Lecturer</span></li>
<li id="toc-li-17"><span href="#/text/ch014#chapter-11-date-81-the-model" title="Link target outside of Sample">Chapter 11 Date 81 – The Model</span></li>
<li id="toc-li-18"><span href="#/text/ch015#chapter-12-date-98-the-personal-trainer" title="Link target outside of Sample">Chapter 12 Date 98 – The Personal Trainer</span></li>
<li id="toc-li-19"><span href="#/text/ch016#chapter-13-date-103-a-true-whore" title="Link target outside of Sample">Chapter 13 Date 103 – A True Whore</span></li>
<li id="toc-li-20"><span href="#/text/ch017#chapter-14-date-109-the-ux-designer" title="Link target outside of Sample">Chapter 14 Date 109 – The UX Designer</span></li>
<li id="toc-li-21"><span href="#/text/ch018#chapter-15-the-realisation" title="Link target outside of Sample">Chapter 15 The Realisation</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?53f4d446